<style scoped>
.navigation-drawer {
  background: lightblue !important;
}
</style>
<style>
.navigation-drawer .theme--light {
  background: lightblue !important;
}
</style>


<template>
  <v-navigation-drawer v-model="$store.state.drawer" app dir="rtl" right class="text-right navigation-drawer"
    :key="componentKey">
    <v-list v-for="route in routes" v-bind:key="route.name" v-show="userHasAccess(route)">
      <template v-if="route.children">
        <v-list-group :prepend-icon="route.icon">
          <template slot='activator'>
            <v-list-item-title class="pr-2">{{ $t(`field.drawer_${route.name}`) }}</v-list-item-title>
          </template>
          <v-list-item :to="subLink.path" v-for="subLink in route.children" v-show="userHasAccess(subLink)"
            v-bind:key="subLink.name">
            <v-list-item-action>
              <v-icon>{{ subLink.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="pr-4">{{ $t(`field.drawer_${subLink.name}`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
      <template v-else>
        <v-list-item :to="route.path">
          <v-list-item-action>
            <v-icon>{{ route.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="pr-2">{{ $t(`field.drawer_${route.name}`) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <v-list>
      <v-list-item href="https://docs.google.com/forms/d/11wf4yPKwsXn2WDFmGB8oTHHqeGsu_ZdhBdSJL3GlnTw">
        <v-list-item-action>
          <v-icon>mdi-comment</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="pr-2">{{ $t(`field.drawer_Feedback`) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import vueRouter from '../../router/index'
// import { PLASMIC } from '../../plasmic-init';

export default {
  name: 'Drawer',
  data() {
    return {
      routes: vueRouter.options.routes,
      componentKey: 0,
    }
  },
  // created() {
  //   PLASMIC.fetchPages().then((pages) => {
  //     const routes = pages.filter(page => page.path !== '/').map(({ name, path }) => ({ name, path, isPublic: false }));
  //     this.routes = [...this.routes, ...routes];
  //   });
  // },
  methods: {
    userHasAccess(route) {
      if (route.isPublic) return true
      if (!this.$store.state.user) return false
      if (this.$store.state.user.internal) return true

      return this.$store.state.user.groups.includes(route.path.substring(1).replace('/', '_'))
    },
    forceRerender() {
      this.componentKey += 1;
    }
  },
  watch: {
    "$store.state.booksCategories": {
      handler: function () {
        this.forceRerender()
      },
      deep: true
    },
    "$store.state.user": {
      handler: function () {
        this.forceRerender()
      },
      deep: true
    }
  }
}
</script>
